//选择企业成员的组件
import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from "react"
import {Input, Space, Checkbox, Pagination} from "antd"
import IconDeleteTag from "../../iconfont/deleteTag/deleteTag";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
const { Search } = Input;
let timer
const MemberCompanies = forwardRef((props,ref)=>{
    const [data,setData]=useState([

    ])//全部数据
    const [selectData,setSelectData]=useState([])//已经选择的数据
    const [nickName,setNickName]=useState('')//筛选的字段
    const [searchData,setSearchData]=useState([])//筛选数据

    const [pagInfo, setPagInfo] = useState({
        pageNum:1,
        pageSize:6,
        total:6
    })
    useEffect(()=>{
        if(props.deleteMember){
            if(props.deleteMember && props.deleteMember!=''){
                setData(props.deleteMember)
                setSearchData(props.deleteMember)
                setSelectData([])
            }
        }else {
            let bodyData={
                wxid:props.wxid,
                chat_wxid:props.chat_wxid,
                nickName:nickName
            }
            CloudApi.getChatWorkMates(6,1,bodyData,(data)=>{
                data.list.forEach((item,index)=>{
                    item.checked=false
                })
                setData(data.list)
                setPagInfo(data.pagInfo)
            },(data)=>{
                Message.error(data.respMsg)
            })
        }

    },[props.wxid,props.chat_wxid])

    useEffect(()=>{

        if(props.deleteMember && props.deleteMember!=''){
            setData(props.deleteMember)
            setSearchData(props.deleteMember)
            setSelectData([])
        }

    },[props.deleteMember])

    function onSearch(value){
        // console.log(value,'777')
    }
    //单选
    function onChange(customerId) {
        let newData=[...data]//获取全部的数据
        let newSelectData=selectData//获取选中的数据
        newData.forEach((item,index)=>{
            if(item.customerId == customerId){
                item.checked=!item.checked
                if(item.checked){
                    newSelectData.push(item)
                    setSelectData(newSelectData)//判断选中的添加到右侧
                }else {
                    newSelectData=selectData.filter(item =>item.customerId !=customerId)
                    setSelectData(newSelectData)//已经勾选住的数据
                }
            }
        })
        setData(newData)
    }
    //点击右侧的删除按钮
    function deleteMember(customerId) {
        let newData=[...data]
        newData.forEach((item)=>{
            if(item.customerId == customerId){
                item.checked=false
            }
        })
        setData(newData)
        setSearchData(newData)
        let newSelectData=selectData.filter(item=>item.customerId!=customerId)
        setSelectData(newSelectData)
    }
    //点击清空按钮
    function emptyData() {
        let newData=[...data]
        newData.forEach((item)=>{
            item.checked=false
        })
        setData(newData)
        let newSelectData=selectData.filter(item=>item.checked)
        setSelectData(newSelectData)
    }
    function exportData() {
        return selectData
    }
    function getSelectData(list){
        let newData=[...data]
        if(newData.length > 0){
            newData.forEach((item,index)=>{
                item.checked=false
                list.forEach((el)=>{
                    if(el.customerId == item.customerId){
                        item.checked = true
                    }
                })
            })
            // let newSelectData=newData.filter(item=>item.checked)
            setData(newData)
            setSelectData(list)
        }
    }
    //搜索事件 Change
    function inputChange(e){
        let value = e.target.value
        setNickName(value)
        clearTimeout(timer)
        timer = setTimeout(()=>{
            if(props.deleteMember){
                let newData=searchData
                setData(newData)
            }else {
                let bodyData={
                    wxid:props.wxid,
                    chat_wxid:props.chat_wxid,
                    nickName:value
                }
                CloudApi.getChatWorkMates(6,1,bodyData,(data)=>{
                    // console.log(data,'企业成员')
                    data.list.forEach((item,index)=>{
                        item.checked=false
                        selectData.forEach((el) => {
                            if (item.customerId == el.customerId) {
                                item.checked = true
                            }
                        })
                    })
                    setData(data.list)
                    setPagInfo(data.pagInfo)
                },()=>{
                    Message.error('获取企业成员列表失败')
                })
            }
        },200)
    }
    //点击搜索按钮进行筛选
    function searchNickNAmeChange(){
        if(props.deleteMember){
            let newData=searchData
            let arr=newData.filter((item)=>{
                return item.nickName.indexOf(nickName) !=-1
            })
            setData(arr)
        }else {
            let bodyData={
                wxid:props.wxid,
                chat_wxid:props.chat_wxid,
                nickName:nickName
            }
            CloudApi.getChatWorkMates(6,1,bodyData,(data)=>{
                // console.log(data,'企业成员')
                data.list.forEach((item,index)=>{
                    item.checked=false
                    selectData.forEach((el) => {
                        if (item.customerId == el.customerId) {
                            item.checked = true
                        }
                    })
                })
                setData(data.list)
                setPagInfo(data.pagInfo)
            },()=>{
                Message.error('获取企业成员列表失败')
            })
        }
    }

    useImperativeHandle(ref, () => ({
        exportData:exportData,
        getSelectData:getSelectData
    }));
    return(
        <div className={'member_companies'}>
            <div>
                {/*添加成员教程？<a>添加成员教程</a>*/}
            </div>
            <div>
                <div className={'member_companies_left'}>
                    <div className={'member_companies_left_search'}>
                        <Space>
                            <Search
                                placeholder="请输入成员昵称"
                                onSearch={onSearch}
                                style={{ width: 291 }}
                                value={nickName}
                                onChange={inputChange}
                                onSearch={searchNickNAmeChange}
                            />
                        </Space>
                    </div>
                    <ul>
                        {
                            data ?
                                <>
                                    {
                                        data && data.map((item,index)=>{
                                            return <li key={index}>
                                                <label>
                                                    <Checkbox checked={item.checked} onChange={onChange.bind(this,item.customerId)}/>
                                                    <div>
                                                        <img src={item.avatar}/>
                                                        <span>
                                                        <span>{item.nickName}</span>
                                                        <span className={item.corpName == '微信' ? 'wx_name' : 'qy_name'}>{props.deleteMember ? <>@{item.corpName}</> : ''}</span>
                                                    </span>
                                                    </div>

                                                </label>
                                            </li>
                                        })
                                    }
                                </> : '暂无数据'
                        }
                    </ul>
                    <div className={'paging_data_set'}>
                        {
                            !props.deleteMember ?
                                <Pagination simple pageSize={6} showLessItems={true} current={pagInfo.pageNum} total={pagInfo.total}
                                            onChange={(pageNum,pageSize)=>{
                                                let bodyData={
                                                    wxid:props.wxid,
                                                    chat_wxid:props.chat_wxid,
                                                    nickName:nickName
                                                }
                                                CloudApi.getChatWorkMates(pageSize,pageNum,bodyData,(data)=>{
                                                    data.list.forEach((item) => {
                                                        item.checked = false
                                                        selectData.forEach((el) => {
                                                            if (item.customerId == el.customerId) {
                                                                item.checked = true
                                                            }
                                                        })
                                                    })
                                                    setData(data.list)
                                                    setPagInfo(data.pagInfo)
                                                },()=>{

                                                })
                                            }}
                                /> : ''
                        }

                    </div>
                </div>
                <div className={'member_companies_right'}>
                    <div>
                        <div>
                            <span>已选客户</span>
                            <span>（{selectData.length}）</span>
                        </div>
                        <span className={'empty_data'} onClick={emptyData}>清空</span>
                    </div>
                    <ul>
                        {
                            selectData && selectData.map((item,index)=>{
                                return <li key={index}>
                                    <div>
                                        <img src={item.avatar}/>
                                        <span>{item.nickName}</span>
                                    </div>
                                    <label onClick={deleteMember.bind(this,item.customerId)}><IconDeleteTag/></label>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
})
export default MemberCompanies